(function () {
  'use strict';

  var activeOffer = null;
  var lastFocusedElement = null;
  var modal = null;

  function parseOfferData(funnel) {
    var dataElement = funnel.querySelector('.js-cart-offer-data');

    if (!dataElement) return null;

    try {
      return JSON.parse(dataElement.textContent || '{}');
    } catch (error) {
      console.error('Herbity cart offer: invalid offer data', error);
      return null;
    }
  }

  function getCartConfig() {
    var configElement = document.getElementById('cart-config');

    if (!configElement) return {};

    try {
      return JSON.parse(configElement.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function emitOfferEvent(action, offerType, data) {
    var detail = {
      action: action,
      offer_type: offerType
    };

    if (data) {
      Object.keys(data).forEach(function (key) {
        detail[key] = data[key];
      });
    }

    window.dispatchEvent(new CustomEvent('herbity:cart-offer', { detail: detail }));

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: 'herbity_cart_offer' }, detail));
    }
  }

  function ensureModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'cart-offer-modal js-cart-offer-modal';
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="cart-offer-modal__backdrop js-cart-offer-close" aria-hidden="true"></div>',
      '<div class="cart-offer-modal__panel" role="dialog" aria-modal="true" aria-label="Special cart offer" tabindex="-1">',
      '  <button class="cart-offer-modal__close js-cart-offer-close" type="button" aria-label="Close offer">&times;</button>',
      '  <div class="cart-offer-modal__content js-cart-offer-modal-content"></div>',
      '  <p class="cart-offer-modal__status js-cart-offer-status" role="status" aria-live="polite"></p>',
      '</div>'
    ].join('');

    document.body.appendChild(modal);
    return modal;
  }

  function setModalBusy(isBusy) {
    if (!modal) return;

    modal.classList.toggle('is-loading', isBusy);
    modal.querySelectorAll('button').forEach(function (button) {
      button.disabled = isBusy;
    });
  }

  function showStatus(message) {
    if (!modal) return;

    var status = modal.querySelector('.js-cart-offer-status');
    status.textContent = message || '';
  }

  function focusFirstAction() {
    if (!modal) return;

    var firstAction = modal.querySelector('.cart-offer-step__accept');
    var panel = modal.querySelector('.cart-offer-modal__panel');
    (firstAction || panel).focus();
  }

  function openModal() {
    ensureModal();
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-offer-modal-open');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      focusFirstAction();
    });
  }

  function closeModal() {
    if (!modal || modal.hidden) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-offer-modal-open');
    modal.hidden = true;
    showStatus('');
    setModalBusy(false);

    if (lastFocusedElement && document.contains(lastFocusedElement)) {
      lastFocusedElement.focus();
    }

    activeOffer = null;
  }

  function renderStep(step) {
    if (!activeOffer) return false;

    var template = activeOffer.funnel.querySelector(
      'template[data-cart-offer-template="' + step + '"]'
    );

    if (!template) return false;

    var modalElement = ensureModal();
    var content = modalElement.querySelector('.js-cart-offer-modal-content');
    content.replaceChildren(template.content.cloneNode(true));
    showStatus('');
    setModalBusy(false);

    if (modalElement.hidden) {
      openModal();
    } else {
      focusFirstAction();
    }

    var offerData = activeOffer.data[step];
    emitOfferEvent('impression', step, {
      product_id: offerData && offerData.productId,
      variant_id: step === 'upgrade' && offerData ? offerData.candidateVariantId : offerData && offerData.variantId
    });

    return true;
  }

  function beginCheckoutOffer(form) {
    var funnel = form.querySelector('.js-cart-offer-funnel');

    if (!funnel || funnel.dataset.cartOfferEnabled !== 'true') return false;

    var data = parseOfferData(funnel);
    if (!data || (!data.upgrade && !data.quantity)) return false;

    activeOffer = {
      form: form,
      funnel: funnel,
      data: data
    };

    if (data.upgrade && renderStep('upgrade')) return true;
    return Boolean(data.quantity && renderStep('quantity'));
  }

  function checkoutWithOptionalDiscount(useDiscount) {
    if (!activeOffer) return;

    var data = activeOffer.data;
    var checkoutUrl = data.checkoutUrl || '/checkout';
    var discountCode = useDiscount ? String(data.discountCode || '').trim() : '';

    modal.classList.remove('is-open');

    if (discountCode) {
      var checkoutIndex = checkoutUrl.lastIndexOf('checkout');
      var rootPath = checkoutIndex > -1 ? checkoutUrl.slice(0, checkoutIndex) : '/';
      var discountUrl = rootPath + 'discount/' + encodeURIComponent(discountCode) +
        '?redirect=' + encodeURIComponent(checkoutUrl);
      window.location.assign(discountUrl);
      return;
    }

    window.location.assign(checkoutUrl);
  }

  function cartUpdate(updates) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    return fetch(root + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw response;
      return response.json();
    });
  }

  function upgradeCartLine() {
    if (!activeOffer || !activeOffer.data.upgrade) return Promise.reject(new Error('Missing upgrade data'));

    var upgrade = activeOffer.data.upgrade;

    return Shopify.theme.cart.getCart().then(function (cart) {
      var updates = {};
      var existingCandidate = cart.items.find(function (item) {
        return Number(item.variant_id) === Number(upgrade.candidateVariantId) &&
          (!item.properties || Object.keys(item.properties).length === 0);
      });

      updates[upgrade.itemKey] = 0;

      if (existingCandidate) {
        updates[existingCandidate.key] = existingCandidate.quantity + 1;
      } else {
        updates[String(upgrade.candidateVariantId)] = 1;
      }

      return cartUpdate(updates);
    });
  }

  function doubleCartLine() {
    if (!activeOffer || !activeOffer.data.quantity) return Promise.reject(new Error('Missing quantity offer data'));

    return Shopify.theme.cart.updateItem(activeOffer.data.quantity.itemKey, { quantity: 2 });
  }

  function getResponseError(error) {
    if (!error || typeof error.json !== 'function') {
      return Promise.resolve('We could not update your cart. Please try again.');
    }

    return error.json().then(function (body) {
      return body.description || body.message || 'We could not update your cart. Please try again.';
    }).catch(function () {
      return 'We could not update your cart. Please try again.';
    });
  }

  function showBumpError(bumpButton, message) {
    var bump = bumpButton.closest('.cart-offer-bump');
    if (!bump) return;

    var error = bump.querySelector('.js-cart-offer-bump-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'cart-offer-bump__error js-cart-offer-bump-error';
      error.setAttribute('role', 'alert');
      bump.appendChild(error);
    }
    error.textContent = message || '';
  }

  function refreshCartView() {
    if (!Shopify.theme.ajaxCart || typeof Shopify.theme.ajaxCart.updateView !== 'function') return Promise.resolve();

    return Shopify.theme.cart.getCart().then(function (cart) {
      Shopify.theme.ajaxCart.updateView(getCartConfig(), cart);
      return cart;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.js-cart-form');
    if (!form) return;

    var submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    if (beginCheckoutOffer(form)) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var bumpButton = event.target.closest('.js-cart-offer-bump-add');
    if (bumpButton) {
      event.preventDefault();
      var funnel = bumpButton.closest('.js-cart-offer-funnel');
      var bumpData = funnel ? parseOfferData(funnel) : null;
      var originalText = bumpButton.textContent;

      if (!bumpData || !bumpData.bump) return;

      bumpButton.disabled = true;
      bumpButton.textContent = 'Adding…';
      showBumpError(bumpButton, '');

      Shopify.theme.cart.addItem(Number(bumpData.bump.variantId), { quantity: 1 })
        .then(function () {
          emitOfferEvent('accept', 'bump', {
            product_id: bumpData.bump.productId,
            variant_id: bumpData.bump.variantId
          });
          return refreshCartView();
        })
        .catch(function (error) {
          return getResponseError(error).then(function (message) {
            bumpButton.disabled = false;
            bumpButton.textContent = originalText;
            showBumpError(bumpButton, message);
          });
        });
      return;
    }

    if (!activeOffer) return;

    if (event.target.closest('.js-cart-offer-close')) {
      event.preventDefault();
      emitOfferEvent('close', 'modal');
      closeModal();
      return;
    }

    if (event.target.closest('.js-cart-offer-upgrade-accept')) {
      event.preventDefault();
      setModalBusy(true);
      showStatus('Updating your bottle size…');

      upgradeCartLine()
        .then(function () {
          emitOfferEvent('accept', 'upgrade', {
            product_id: activeOffer.data.upgrade.productId,
            from_variant_id: activeOffer.data.upgrade.originalVariantId,
            variant_id: activeOffer.data.upgrade.candidateVariantId
          });
          checkoutWithOptionalDiscount(false);
        })
        .catch(function (error) {
          return getResponseError(error).then(function (message) {
            showStatus(message);
            setModalBusy(false);
          });
        });
      return;
    }

    if (event.target.closest('.js-cart-offer-upgrade-decline')) {
      event.preventDefault();
      emitOfferEvent('decline', 'upgrade', {
        product_id: activeOffer.data.upgrade.productId,
        variant_id: activeOffer.data.upgrade.candidateVariantId
      });

      if (!activeOffer.data.quantity || !renderStep('quantity')) {
        checkoutWithOptionalDiscount(false);
      }
      return;
    }

    if (event.target.closest('.js-cart-offer-quantity-accept')) {
      event.preventDefault();
      setModalBusy(true);
      showStatus('Adding your second bottle…');

      doubleCartLine()
        .then(function () {
          emitOfferEvent('accept', 'quantity', {
            product_id: activeOffer.data.quantity.productId,
            variant_id: activeOffer.data.quantity.variantId,
            quantity: 2,
            discount_percent: activeOffer.data.discountPercent
          });
          checkoutWithOptionalDiscount(true);
        })
        .catch(function (error) {
          return getResponseError(error).then(function (message) {
            showStatus(message);
            setModalBusy(false);
          });
        });
      return;
    }

    if (event.target.closest('.js-cart-offer-quantity-decline')) {
      event.preventDefault();
      emitOfferEvent('decline', 'quantity', {
        product_id: activeOffer.data.quantity.productId,
        variant_id: activeOffer.data.quantity.variantId
      });
      checkoutWithOptionalDiscount(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      emitOfferEvent('close', 'modal');
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(
      modal.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return element.offsetParent !== null;
    });

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
